/**
 * @description 判断是否是本地开发环境
 * @returns boolean
 */
const isDev = (): boolean =>
  /dev\.duitang\.net|localhost|127\.0\.0\.1|0\.0\.0\.0/.test(window.location.host);

export default isDev;
